import type { FC } from 'react';

import { useAccountBiddingCounts } from 'Utilities/hooks/account/useAccountBiddingCounts';

import AccountSidebarSegment from './AccountSidebarSection/AccountSidebarSection';
import AccountSidebarSeparator from './AccountSidebarSeparator/AccountSidebarSeparator';
import { ACCOUNT_SIDEBAR_SECTIONS } from './AccountSidebar.consts';

const AccountSidebar: FC = () => {
	const { data: countsData, isLoading } = useAccountBiddingCounts();

	const commonProps = {
		countsData,
		isCountsLoading: isLoading,
	};

	return (
		<>
			<AccountSidebarSegment {...commonProps} section={ACCOUNT_SIDEBAR_SECTIONS.bids} />
			<AccountSidebarSeparator />
			<AccountSidebarSegment {...commonProps} section={ACCOUNT_SIDEBAR_SECTIONS.purchases} />
		</>
	);
};

export default AccountSidebar;
